export { default } from "bullitttime-embermodelsgochips/serializers/device";
